import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import PDFNUpToolImagesListSheet from "./PDFNUpToolImagesListSheet";
import { BASE_URL } from "../Config";

function PDFNUpToolMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF N-Up Tool, Print Multiple Pages Per Sheet Per Paper",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_n_up_tool", title: "PDF N-Up Tool Free" },
    data2: { link: "/pdf_n_up_tool", title: "PDF Imposition Free" },
    data3: {
      link: "/pdf_n_up_tool",
      title: "Set Multiple PDF Pages Per Sheet For Printing",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Use PDF N-Up online to place multiple pages on one sheet. Create 2-up, 4-up, or more layouts easily with our fast PDF N-Up tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf n up, pdf n-up tool, n-up pdf, multiple pages per sheet pdf, pdf 2-up, pdf 4-up, pdf page layout tool, print multiple pages pdf, pdf layout editor, pdf imposition tool, pdf pages per sheet, pdf editor online, n-up printing pdf, pdf document layout, pdf formatting tool, print multiple pdf pages per sheet, multiple pdf pages in single sheet,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <PDFNUpToolImagesListSheet title={title}></PDFNUpToolImagesListSheet>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Print Multiple PDF Pages Per Sheet Per Paper website provides a smart and efficient solution for printing PDF documents while saving paper, ink, and time. Designed to work fully offline, this powerful tool allows users to arrange and print multiple PDF pages on a single sheet without requiring an internet connection, ensuring complete privacy and security. With advanced layout options, users can easily set multiple PDF pages per page online when needed or use offline processing to achieve the same results directly on their device. This website supports popular N-Up layouts such as 2-up, 4-up, 6-up, and more, making it a reliable PDF N-Up tool online with offline capabilities. Ideal for students, educators, and professionals, the platform helps you print multiple PDF pages per sheet online or offline while preserving original content quality and readability. The tool also supports professional PDF imposition online features, allowing users to control page order, orientation, margins, and scaling for optimized printing results. By arranging multiple pages per paper, users can significantly reduce printing costs and improve document organization. Whether you need to review documents, print handouts, or archive files efficiently, this offline-ready solution offers a fast, user-friendly way to manage PDF layouts. If you are searching for a secure and reliable tool to print multiple PDF pages per sheet, set multiple PDF pages per page online, or use a PDF N-Up tool online with offline support, this website delivers a seamless and professional PDF printing experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Arrange",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF N-Up Tool"
            why_use={[
              {
                title: "Print Multiple PDF Pages Per Sheet",
                description:
                  "A PDF N-Up tool allows you to print multiple PDF pages per sheet, helping reduce paper usage and optimize printing layouts.",
              },
              {
                title: "Save Paper and Printing Costs",
                description:
                  "Using print multiple PDF pages per sheet online helps save paper, ink, and toner, making printing more cost-effective.",
              },
              {
                title: "Organize Documents More Efficiently",
                description:
                  "With set multiple PDF pages per page online, documents appear more structured and easier to review or share.",
              },
              {
                title: "Ideal for Study Materials and Handouts",
                description:
                  "Students and teachers benefit from PDF N-Up tool online features when printing notes, presentations, and handouts.",
              },
              {
                title: "Improve Document Review and Proofreading",
                description:
                  "Viewing multiple pages on one sheet makes proofreading faster. A print multiple PDF pages per sheet online feature enhances productivity.",
              },
              {
                title: "Professional PDF Imposition Layouts",
                description:
                  "Our PDF imposition online tool ensures correct page order, spacing, and alignment for professional-quality printing.",
              },
              {
                title: "Preserve Original Content Quality",
                description:
                  "Modern PDF N-Up tools maintain text clarity and layout when printing multiple PDF pages per sheet.",
              },
              {
                title: "Offline Processing for Better Privacy",
                description:
                  "This offline PDF N-Up tool processes documents locally, keeping sensitive files secure without uploading them to the internet.",
              },
              {
                title: "Support Multiple Layout Options",
                description:
                  "Users can choose 2-up, 4-up, or custom layouts using a flexible PDF N-Up tool online or offline.",
              },
            ]}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default PDFNUpToolMain;
